var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path0, _g8, _path1, _g9, _path10, _g0, _path11, _g1, _path12, _g10, _path13, _g11, _path14, _g12, _path15, _g13, _path16, _g14, _path17, _g15, _path18, _g16, _path19, _g17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgI3WebLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 27,
    viewBox: "0 0 92 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0729 17.7386L10.932 16.2909C11.8293 17.1481 13.3185 17.7386 14.9604 17.7386C17.0032 17.7386 18.1678 16.8052 18.1678 15.3384C18.1678 13.8907 17.1369 12.9573 14.8268 12.9573H13.7767V11.662L17.1751 7.4712H10.6838V5.89014H19.4852V7.12832L15.9341 11.5096C18.6451 11.7382 20.0007 13.2621 20.0007 15.3194C20.0007 17.5672 18.3588 19.3768 14.9795 19.3768C13.0703 19.3768 11.1993 18.7482 10.0729 17.7386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7354 12.5573V17.6433H28.4011C31.7421 17.6433 33.8804 15.5861 33.8804 12.5573C33.8804 9.52849 31.7421 7.4712 28.4011 7.4712H22.9217V5.89014H28.5156C32.8113 5.89014 35.7133 8.59509 35.7133 12.5573C35.7133 16.5195 32.8113 19.2244 28.5156 19.2244H22.9217V12.5573H24.7354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2927 19.2244H41.3454L36.8779 5.89014H38.768L42.4145 16.8433L46.1947 5.89014H47.8939L51.6168 16.8814L55.3397 5.89014H57.0771L52.6096 19.2244H50.6813L46.9966 8.4808L43.2927 19.2244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4636 5.81396H68.8377V7.39503H59.4636V5.81396ZM59.4636 11.681H68.8377V13.224H59.4636V11.681ZM59.4636 19.2244H68.8377V17.6434H59.4636V19.2244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2552 5.89014H78.2119C81.2666 5.89014 82.9848 7.18547 82.9848 9.338C82.9848 10.7857 82.2212 11.8144 81.1329 12.3096C82.6794 12.7287 83.6721 13.8526 83.6721 15.6242C83.6721 17.91 81.9539 19.2244 78.5937 19.2244H72.2552V17.7386H78.5173C80.6747 17.7386 81.8393 17.0528 81.8393 15.4718C81.8393 13.9097 80.6747 13.2049 78.5173 13.2049H72.2552V11.7191H78.04C80.0065 11.7191 81.152 10.9953 81.152 9.54754C81.152 8.09982 80.0065 7.37596 78.04 7.37596H72.2552V5.89014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1996)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 20,
    width: 73,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6327 20.4243H8.11023V24.6722H80.6327V20.4243Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49207 23.6625V20.9956H8.92736V23.6625H8.49207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1314 22.5005V23.6625H12.7114V22.55C12.7114 22.1728 12.5205 21.9862 12.1921 21.9862C11.8293 21.9862 11.5888 22.2033 11.5888 22.6262V23.6625H11.1688V21.6357H11.5697V21.9061C11.7224 21.7157 11.9744 21.6128 12.2799 21.6128C12.7725 21.6128 13.1314 21.8947 13.1314 22.5005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3465 21.9786H15.7813V23.0148C15.7813 23.2206 15.8883 23.3349 16.083 23.3349C16.1861 23.3349 16.2854 23.3044 16.3579 23.2472L16.4839 23.5482C16.3694 23.6396 16.2014 23.6854 16.0334 23.6854C15.6057 23.6854 15.3613 23.4568 15.3613 23.0263V21.9786H15.0215V21.6357H15.3613V21.1899H15.7813V21.6357H16.3465V21.9786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1831 22.6491C18.1831 22.0471 18.6222 21.6128 19.2179 21.6128C19.8136 21.6128 20.2336 22.0357 20.2336 22.6643C20.2336 22.6986 20.2298 22.7519 20.2259 22.7938H18.6069C18.6604 23.11 18.9239 23.3196 19.3019 23.3196C19.5348 23.3196 19.7257 23.2434 19.8708 23.0872L20.0999 23.3577C19.9166 23.571 19.6341 23.6853 19.2904 23.6853C18.6222 23.6853 18.1831 23.2548 18.1831 22.6491ZM19.8326 22.4929C19.7906 22.1805 19.5501 21.9671 19.2179 21.9671C18.8895 21.9671 18.6489 22.1766 18.6031 22.4929H19.8326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2458 23.6623V20.8354H22.6659V23.6623H22.2458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8577 23.6623V20.8354H25.2777V23.6623H24.8577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4045 21.0109C27.4045 20.8662 27.5229 20.748 27.6794 20.748C27.836 20.748 27.9543 20.8585 27.9543 21.0033C27.9543 21.1557 27.8398 21.2738 27.6794 21.2738C27.5229 21.2738 27.4045 21.1595 27.4045 21.0109ZM27.4694 23.6625V21.6357H27.8894V23.6625H27.4694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3226 23.3805L32.5211 23.0338C32.7082 23.1977 33.0022 23.3082 33.3153 23.3082C33.6934 23.3082 33.9148 23.1405 33.9148 22.8738C33.9148 22.6148 33.7239 22.4471 33.2924 22.4471H33.0633V22.1385L33.6972 21.3728H32.4524V20.9956H34.247V21.2928L33.575 22.1043C34.0943 22.1652 34.3539 22.4662 34.3539 22.87C34.3539 23.3196 34.0179 23.6967 33.3192 23.6967C32.9411 23.6967 32.5631 23.5786 32.3226 23.3805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8626 22.329V23.2853H37.5499C38.1799 23.2853 38.5847 22.9043 38.5847 22.329C38.5847 21.7538 38.1799 21.3728 37.5499 21.3728H36.4273V20.9956H37.5728C38.4358 20.9956 39.0238 21.5328 39.0238 22.329C39.0238 23.1253 38.4358 23.6625 37.5728 23.6625H36.4273V22.329H36.8626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7629 23.6625H44.297L43.4073 20.9956H43.8579L44.5529 23.0948L45.2745 20.9956H45.6793L46.3857 23.1062L47.0959 20.9956H47.5121L46.6224 23.6625H46.1604L45.4655 21.6166L44.7629 23.6625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0929 22.6491C49.0929 22.0471 49.532 21.6128 50.1277 21.6128C50.7233 21.6128 51.1434 22.0357 51.1434 22.6643C51.1434 22.6986 51.1395 22.7519 51.1357 22.7938H49.5167C49.5702 23.11 49.8337 23.3196 50.2117 23.3196C50.4446 23.3196 50.6355 23.2434 50.7806 23.0872L51.0097 23.3577C50.8264 23.571 50.5439 23.6853 50.2002 23.6853C49.532 23.6853 49.0929 23.2548 49.0929 22.6491ZM50.7424 22.4929C50.7004 22.1805 50.4599 21.9671 50.1277 21.9671C49.7993 21.9671 49.5587 22.1766 49.5129 22.4929H50.7424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5566 23.6623H53.1556V20.8354H53.5757V21.8984C53.7437 21.7041 53.9842 21.6126 54.2477 21.6126C54.8472 21.6126 55.2825 22.0241 55.2825 22.6489C55.2825 23.2737 54.8472 23.6852 54.2477 23.6852C53.969 23.6852 53.7208 23.5861 53.5566 23.3842V23.6623ZM54.8586 22.6489C54.8586 22.2413 54.5799 21.9784 54.2133 21.9784C53.8468 21.9784 53.568 22.2413 53.568 22.6489C53.568 23.0566 53.8468 23.3194 54.2133 23.3194C54.5799 23.3194 54.8586 23.0566 54.8586 22.6489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1207 23.6625H60.6893L59.517 20.9956H59.9905L60.9184 23.1215L61.8539 20.9956H62.2892L61.1207 23.6625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0266 21.0109C64.0266 20.8662 64.1449 20.748 64.3015 20.748C64.458 20.748 64.5764 20.8585 64.5764 21.0033C64.5764 21.1557 64.4618 21.2738 64.3015 21.2738C64.1449 21.2738 64.0266 21.1595 64.0266 21.0109ZM64.0915 23.6625V21.6357H64.5115V23.6625H64.0915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5238 22.6491C66.5238 22.0471 66.9629 21.6128 67.5586 21.6128C68.1543 21.6128 68.5743 22.0357 68.5743 22.6643C68.5743 22.6986 68.5705 22.7519 68.5666 22.7938H66.9476C67.0011 23.11 67.2646 23.3196 67.6426 23.3196C67.8755 23.3196 68.0664 23.2434 68.2115 23.0872L68.4406 23.3577C68.2574 23.571 67.9748 23.6853 67.6311 23.6853C66.9629 23.6853 66.5238 23.2548 66.5238 22.6491ZM68.1733 22.4929C68.1313 22.1805 67.8908 21.9671 67.5586 21.9671C67.2302 21.9671 66.9896 22.1766 66.9438 22.4929H68.1733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3884 23.6625H70.9874L70.2352 21.6357H70.6323L71.1975 23.1939L71.7855 21.6357H72.1406L72.7172 23.1939L73.2976 21.6357H73.6718L72.9157 23.6625H72.5148L71.9573 22.1958L71.3884 23.6625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3137 22.6491C75.3137 22.0471 75.7528 21.6128 76.3484 21.6128C76.9441 21.6128 77.3641 22.0357 77.3641 22.6643C77.3641 22.6986 77.3603 22.7519 77.3565 22.7938H75.7375C75.791 23.11 76.0544 23.3196 76.4324 23.3196C76.6654 23.3196 76.8563 23.2434 77.0014 23.0872L77.2305 23.3577C77.0472 23.571 76.7646 23.6853 76.421 23.6853C75.7528 23.6853 75.3137 23.2548 75.3137 22.6491ZM76.9632 22.4929C76.9212 22.1805 76.6806 21.9671 76.3484 21.9671C76.0201 21.9671 75.7795 22.1766 75.7337 22.4929H76.9632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7965 23.6625H79.3765V21.6357H79.7774V21.9442C79.911 21.7271 80.163 21.6128 80.5067 21.6128V22.0204C80.4723 22.0166 80.4418 22.0128 80.4112 22.0128C80.0332 22.0128 79.7965 22.2376 79.7965 22.6681V23.6625Z",
    fill: "white"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30876 8.00049H6.55231V19.2203H8.30876V8.00049Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43058 3.6079C7.40767 3.6079 7.3924 3.58885 7.3924 3.5698V3.3755C7.3924 3.35264 7.41149 3.3374 7.43058 3.3374C7.45349 3.3374 7.46876 3.35645 7.46876 3.3755V3.5698C7.46876 3.59266 7.44967 3.6079 7.43058 3.6079Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33933 3.98522C8.32788 3.98522 8.32024 3.98142 8.3126 3.9738C8.29733 3.95856 8.29733 3.93189 8.3126 3.91665L8.45006 3.7795C8.46534 3.76426 8.49207 3.76426 8.50734 3.7795C8.52261 3.79473 8.52261 3.8214 8.50734 3.83664L8.36988 3.9738C8.35842 3.98142 8.35079 3.98522 8.33933 3.98522Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.38053 5.93933C6.36908 5.93933 6.36144 5.93552 6.3538 5.9279C6.33853 5.91266 6.33853 5.88599 6.3538 5.87075L6.49126 5.7336C6.50654 5.71836 6.53327 5.71836 6.54854 5.7336C6.56381 5.74884 6.56381 5.77551 6.54854 5.79074L6.41108 5.9279C6.40344 5.93552 6.39199 5.93933 6.38053 5.93933Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.91212 4.89163H8.71738C8.69447 4.89163 8.6792 4.87258 8.6792 4.85353C8.6792 4.83067 8.69829 4.81543 8.71738 4.81543H8.91212C8.93503 4.81543 8.9503 4.83448 8.9503 4.85353C8.9503 4.87639 8.93503 4.89163 8.91212 4.89163Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14375 4.89163H5.94901C5.9261 4.89163 5.91083 4.87258 5.91083 4.85353C5.91083 4.83067 5.92992 4.81543 5.94901 4.81543H6.14375C6.16666 4.81543 6.18193 4.83448 6.18193 4.85353C6.18193 4.87639 6.16284 4.89163 6.14375 4.89163Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47679 5.93933C8.46534 5.93933 8.4577 5.93552 8.45006 5.9279L8.3126 5.79074C8.29733 5.77551 8.29733 5.74884 8.3126 5.7336C8.32788 5.71836 8.3546 5.71836 8.36988 5.7336L8.50734 5.87075C8.52261 5.88599 8.52261 5.91266 8.50734 5.9279C8.4997 5.93552 8.48825 5.93933 8.47679 5.93933Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51799 3.98522C6.50654 3.98522 6.4989 3.98142 6.49126 3.9738L6.3538 3.83664C6.33853 3.8214 6.33853 3.79473 6.3538 3.7795C6.36907 3.76426 6.3958 3.76426 6.41108 3.7795L6.54854 3.91665C6.56381 3.93189 6.56381 3.95856 6.54854 3.9738C6.5409 3.98142 6.52945 3.98522 6.51799 3.98522Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92693 3.70677C7.92311 3.70677 7.91547 3.70676 7.91165 3.70296C7.89256 3.69534 7.88111 3.67248 7.88874 3.64962L7.96511 3.47056C7.97275 3.45151 7.99566 3.44008 8.01857 3.4477C8.03766 3.45532 8.04912 3.47818 8.04148 3.50104L7.96511 3.6801C7.95748 3.69915 7.9422 3.70677 7.92693 3.70677Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62192 4.40398C8.60665 4.40398 8.59137 4.39636 8.58374 4.38112C8.5761 4.36207 8.58374 4.33921 8.60665 4.33159L8.78611 4.25921C8.8052 4.25159 8.82811 4.2592 8.83575 4.28206C8.84338 4.30111 8.83575 4.32397 8.81284 4.33159L8.63337 4.40398C8.62956 4.40398 8.62574 4.40398 8.62192 4.40398Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05979 5.45574C6.04451 5.45574 6.02924 5.44812 6.0216 5.43288C6.01396 5.41383 6.0216 5.39097 6.04451 5.38335L6.22398 5.31096C6.24307 5.30334 6.26598 5.31096 6.27361 5.33382C6.28125 5.35287 6.27361 5.37573 6.2507 5.38335L6.07124 5.45574C6.06742 5.45193 6.0636 5.45574 6.05979 5.45574Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79755 5.46328C8.79374 5.46328 8.7861 5.46328 8.78228 5.45947L8.60282 5.38327C8.58373 5.37565 8.57227 5.35279 8.57991 5.32993C8.58754 5.31088 8.61045 5.29945 8.63336 5.30707L8.81283 5.38327C8.83192 5.39089 8.84337 5.41375 8.83574 5.43661C8.8281 5.45566 8.81283 5.46328 8.79755 5.46328Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24305 4.39638C6.23923 4.39638 6.23159 4.39638 6.22778 4.39257L6.04831 4.31638C6.02922 4.30876 6.01777 4.2859 6.0254 4.26304C6.03304 4.24399 6.05595 4.23256 6.07886 4.24018L6.25832 4.31638C6.27741 4.324 6.28887 4.34685 6.28123 4.36971C6.2736 4.38876 6.25832 4.39638 6.24305 4.39638Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94178 3.70303C6.92651 3.70303 6.91124 3.69541 6.9036 3.68018L6.83105 3.50112C6.82341 3.48207 6.83105 3.45921 6.85396 3.45159C6.87305 3.44397 6.89596 3.45159 6.9036 3.47445L6.97615 3.65351C6.98379 3.67256 6.97615 3.69541 6.95324 3.70303C6.95324 3.70303 6.9456 3.70303 6.94178 3.70303Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.77424 6.72797H7.10602C7.06784 6.72797 7.03729 6.69749 7.03729 6.6594C7.03729 6.6213 7.06784 6.59082 7.10602 6.59082H7.77424C7.81242 6.59082 7.84297 6.6213 7.84297 6.6594C7.84297 6.69749 7.81242 6.72797 7.77424 6.72797Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.77424 6.94135H7.10602C7.06784 6.94135 7.03729 6.91087 7.03729 6.87278C7.03729 6.83468 7.06784 6.8042 7.10602 6.8042H7.77424C7.81242 6.8042 7.84297 6.83468 7.84297 6.87278C7.84297 6.91087 7.81242 6.94135 7.77424 6.94135Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.28166 7.02148C7.26638 7.02148 7.25111 7.03672 7.25493 7.05196C7.2702 7.13959 7.34657 7.20435 7.44203 7.20435C7.53749 7.20435 7.61004 7.13959 7.62913 7.05196C7.63295 7.03672 7.62149 7.02148 7.6024 7.02148H7.28166Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_0_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 27
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H0V27H92V0Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_0_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6253 3.84041C7.51075 3.81755 7.38856 3.81755 7.27401 3.8366C6.78144 3.9166 6.42633 4.33568 6.42633 4.83095C6.42633 5.2005 6.57525 5.42909 6.71653 5.64625C6.84635 5.84817 6.96854 6.03866 6.99145 6.33963C6.99909 6.43107 7.07545 6.50345 7.17091 6.50345H7.70549C7.79713 6.50345 7.87731 6.43107 7.88495 6.33963C7.90786 6.03866 8.03005 5.84817 8.15987 5.64625C8.30115 5.42528 8.45007 5.19669 8.45007 4.83095C8.45007 4.34711 8.1026 3.92803 7.6253 3.84041ZM6.98763 5.45195C6.97618 5.45957 6.9609 5.46338 6.94945 5.46338C6.93036 5.46338 6.90745 5.45576 6.89599 5.43671C6.52943 4.93763 6.80053 4.46521 6.81199 4.44616C6.83108 4.41569 6.86926 4.40426 6.90363 4.4233C6.93417 4.44235 6.94563 4.48045 6.92654 4.51474C6.91508 4.53379 6.6898 4.93382 7.00291 5.36051C7.022 5.38718 7.01436 5.42909 6.98763 5.45195Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3WebLogo);
export default __webpack_public_path__ + "static/media/i3web-logo.e4779c985be60b75592b42ca6886f7a1.svg";
export { ForwardRef as ReactComponent };